// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__je9o4","heading":"styles_heading__I3vmo","container":"styles_container__TXvfv"};